import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-cart-notice',
  templateUrl: './cart-notice.component.html',
  styleUrls: ['../notice/notice.component.scss']
})
export class CartNoticeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
